<template>
  <div class="page page-index">
    <div class="table-of-contents-container">
      <section class="index-section content-section">
        <h2 class="table-of-contents-title">Table of contents</h2>
        <TableOfContents
          :onePageMode="onePageMode"
          :readOnly="readOnly"
          v-on="{ changePage }"
        />
      </section>

      <section class="index-section footer-section">
        <PromoArea />
      </section>
    </div>
  </div>
</template>

<script>
//const CHUNK_SIZE = 8;

import PromoArea from "@/components/Projects/Playbooks/Index/PromoArea.vue";
import TableOfContents from "@/components/Projects/Playbooks/Index/TableOfContents.vue";

export default {
  name: "Index",
  props: {
    page: {
      type: Object,
    },
    onePageMode: {
      type: Boolean,
    },
    readOnly: {
      type: Boolean,
    },
  },

  computed: {
    /* divide into two columns */
    /* chunks() {
      return Math.ceil(this.tableOfContents.length / 8);
    },*/
  },
  methods: {
    /* slicedContents(chunk) {
      return this.tableOfContents?.slice(
        CHUNK_SIZE * chunk,
        CHUNK_SIZE * chunk + CHUNK_SIZE - 1
      );
    },*/

    changePage(pageNumber) {
      this.$emit("changePage", pageNumber);
    },
  },
  components: {
    PromoArea,
    TableOfContents,
  },
};
</script>

<style lang="scss">
#app {
  .page-index {
    font-family: $slateStd;
    .table-of-contents-container {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding-top: 2em;
      padding-left: 2em;
      padding-right: 2em;

      .index-section {
        overflow: hidden;
      }
      .content-section {
        height: 35%;

        .table-of-contents-title {
          margin-bottom: 1em;
          font-family: "ForzaBold";
          font-weight: bold;
          font-size: 2em;
          height: 1.25em;
          margin-bottom: 1em;
          text-transform: uppercase;
        }
      }

      @media screen and (max-width: 576px) {
        margin: 0.25rem;
      }
    }
  }

  .template-fsg {
    .content-section {
      //height: 40%;
    }
    .footer-section {
      //height: 60%;
    }
    .table-of-contents-items-container {
      position: relative;
      display: flex;
      flex-direction: row;
      width: 100%;
      padding: 0 1em;
      min-height: 20em;
      .loading-table {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .table-of-contents-branding {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
      }
    }
  }
}
</style>
